import(/* webpackMode: "eager" */ "/codebuild/output/src3517620116/src/webapp/src/app/global-error.tsx");
